export default function Logo({ height = 44, variant = 'icon', className = '' }) {
  const src = variant === 'full' ? '/logo/scorpion.png' : '/logo/scorpion-icon.png';
  return (
    <img
      src={src}
      alt="Scorpion Funding"
      style={{ height, width: 'auto' }}
      className={`select-none pointer-events-none ${className}`}
      draggable="false"
    />
  );
}
